<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchSaleReturnProducts(1)" class="form-inline my-2 my-lg-0">
                    <input v-model="search.cn_number"
                           class="form-control mr-sm-2"
                           type="text"
                           placeholder="เลขที่ใบคืนสินค้า"/>
                    &nbsp;
                    <input v-model="search.invoice_id"
                           class="form-control mr-sm-2"
                           type="text"
                           placeholder="บิลขาย TN"/>
                    &nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.product"
                        :customLabel="productLabel"
                        :options="optionProduct"
                        :show-labels="false"
                        placeholder="ค้นหาสินค้า"
                        track-by="id">
                    </multiselect>
                    &nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :customLabel="customerLabel"
                        :options="customerOption"
                        :show-labels="false"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <date-picker range
                                 v-model="search.date"
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp&nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchSaleReturnProducts(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp&nbsp
                    <button class="btn btn-warning my-2 my-sm-0 mr-2"
                            type="button"
                            v-if="canViewAccounting"
                            @click="toForm1">
                        <icon name="plus"></icon>
                        สร้างรายการคืนสินค้า
                    </button>
                    &nbsp&nbsp
                    <button class="btn btn-info my-2 my-sm-0"
                            type="button"
                            v-if="canViewAccounting"
                            @click="printReturn"
                            :disabled='isDisabled'>
                        <icon name="plus"></icon>
                        สร้างรายการลดหนี้
                    </button>
                    &nbsp&nbsp
                    <button class="btn btn-info my-2 my-sm-0"
                            type="button"
                            v-if="canViewAccounting"
                            @click="showExportModal">
                        รายงานคืนสินค้า Excel
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                    </th>
                    <th>สถานะสร้างใบลดหนี้</th>
                    <th>วันที่สร้างรายการคืนสินค้า</th>
                    <th>เลขที่ใบคืนสินค้า</th>
                    <th>วันที่สร้างใบคืนสินค้า</th>
                    <th>เลขที่ใบแจ้งหนี้สำหรับหักคืน</th>
                    <th>ยอดที่คืน (บาท)</th>
                    <th>ชื่อเซลล์</th>
                    <th>ชื่อลูกค้า</th>
                    <th>สถานะ</th>
                    <th>วันที่อัพเดท</th>
                    <th>พิมพ์</th>
                    <th v-if="canViewAccounting">แก้ไข / ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in saleReturnProductList">
                    <td>
                        <input type="checkbox" v-model="checkbox_id"
                               :disabled="data.status_credit_note"
                               :value="data.id"/>
                    </td>
                    <td>
                        <template v-if="data.status_credit_note">
                            <icon name="check" color="green"></icon>
                        </template>
                        <template v-else>
                            <icon name="minus" color="red"></icon>
                        </template>
                    </td>
                    <td>
                        {{ data.date | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.cn_number">
                            {{ data.cn_number }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.cn_number">
                            {{ data.updated_at | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.invoice_back.length > 0">
                            <span v-for="invoice in data.invoice_back">
                                - {{ invoice.invoice_number }} <span
                                style="color: #00a699">({{ invoice.invoice.total | currency }} บาท)</span><br/>
                            </span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.return_price | currency }}</td>
                    <td>
                        <template v-if="data.sale">
                            {{ data.sale.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer">
                            {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.status_id == 1">
                            <a style="color: darkred;text-decoration: underline"
                               @click="goToSaleReturnProductsForm1(2,data.id)">รอตรวจสอบ</a>
                        </template>
                        <template v-else>
                            <label style="color: green;">เสร็จสิ้นแล้ว</label>
                        </template>
                    </td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <button type="button"
                                @click="printSaleReturnProduct(data.id)"
                                class="btn btn-primary">
                            พิมพ์
                        </button>
                    </td>
                    <td v-if="canViewAccounting">
                        <a @click="goToSaleReturnProductsForm1(1,data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--delete-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteSaleReturnProducts">ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">ยกเลิก
                </button>
            </div>
        </b-modal>
        <div v-if="saleReturnProductList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSaleReturnProducts">
            </vue-pagination>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="export_modal">
            <div style="text-align: center;">
                <div class="row">
                    <div class="col-3 text-right">เดือน/ปี</div>
                    <div class="col-8">
                        <date-picker
                            :lang="lang"
                            type="month"
                            class="w-100"
                            :format="changeFormat"
                            v-model="export_excel.month_year"
                            placeholder="เดือน-ปี"
                            confirm
                            format="MM/YYYY">
                        </date-picker>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-right">เซล</div>
                    <div class="col-8">
                        <multiselect
                            v-model="export_excel.sale_id"
                            :options="sellers"
                            track-by="id"
                            :multiple="true"
                            label="name"
                            :close-on-select="false"
                            :show-labels="false"
                            placeholder="เลือกเซลล์">
                        </multiselect>
                    </div>
                </div>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="exportSaleReturn">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideExportModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <br>
        <!--        <pre class="alert-primary">{{checkbox_id}}</pre>-->
        <!--<pre class="alert-primary">{{saleReturnProductList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import moment from "moment";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";
import {canViewAccounting} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    components: {
        Loading,
        VuePagination,
        DatePicker,
        Multiselect,
    },
    props: {
        status: {default: null}
    },
    name: "sale-return-products-list",
    created() {
        this.$store.dispatch("SaleReturnProduct/setSaleReturnProduct").then(() => {
            this.$store.dispatch("SaleReturnProduct/clearSearch").then(() => {
                this.getCustomerAll();
                this.getCurrentDate();
            });
        });
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            customerOption: [],
            delete_id: "",
            checkbox_id: [],
            currentDate: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            export_excel: {
                'sale_id': [],
                'month_year': ''
            }
        };
    },
    computed: {
        canViewAccounting,
        ...mapState({
            optionProduct: state => {
                return state.Products.product_all;
            },
            saleReturnProductList: state => {
                return state.SaleReturnProduct.saleReturnProductList;
            },
            search: state => {
                return state.SaleReturnProduct.search;
            },
            dataPaginate: state => {
                return state.SaleReturnProduct.dataPaginate;
            },
            sellers: state => {
                return state.Seller.data;
            },
        }),
        // selectAll: {
        //     get: function () {
        //         return this.saleReturnProductList ? this.checkbox_id.length >= this.saleReturnProductList.length : false;
        //     },
        //     set: function (value) {
        //         if (value) {
        //             this.select_all = true;
        //         } else {
        //             this.select_all = false;
        //             this.checkbox_id = [];
        //         }
        //     }
        // },
        isDisabled: function () {
            return this.checkbox_id.length > 0 ? false : true;
        }
    },
    methods: {
        exportSaleReturn() {
            let date = moment(this.export_excel.month_year).format('MM/YYYY');

            let id = '';
            this.export_excel.sale_id.forEach((x, i) => {
                if (i > 0) id += ',' + x.id;
                else id += x.id;
            });
            window.open(domain + '/sale-return-product-excel?sale=' + id + '&month=' + date, '_blank')
        },
        printReturn() {
            let data = {
                id: this.checkbox_id.length > 0 ? this.checkbox_id.toString() : '',
            };
            this.showLoadingModal()
            this.status_loading = 1;
            this.msg = "กรุณารอสักครู๋";
            this.$store.dispatch("SaleReturnProduct/createCreditnote", data).then(res => {
                this.hideLoadingModal()
                this.$router.push('/accounting/credit-note');
            }).catch(err => {
                //console.log(err);
                this.showLoadingModal()
                this.status_loading = 3;
                this.msg = "สร้างใบลดหนี้ไม่สำเร็จ";
            });
        },
        productLabel(option) {
            return `${option.sku} - ${option.short_name}`
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.customerOption = res;
            });
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showExportModal() {
            this.$refs.export_modal.show();
        },
        hideExportModal() {
            this.$refs.export_modal.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        goToSaleReturnProductsForm1(status_id, id) {
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("SaleReturnProduct/getSaleReturnProductByID", id).then(() => {
                this.$router.push({
                    name: "sale-return-products-form1",
                    params: {status: status_id}
                })
            }).catch(() => {
                this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                this.status_loading = 3;
                this.showLoadingModal();
            });
        },
        deleteSaleReturnProducts() {
            this.showLoadingModal();
            this.status_loading = 1;
            this.msg = 'กำลังลบข้อมูล';
            this.$store.dispatch("SaleReturnProduct/deleteSaleReturnProduct", this.delete_id).then(() => {
                this.$store.dispatch("SaleReturnProduct/setSaleReturnProduct").then(() => {
                    this.showLoadingModal();
                    this.status_loading = 2;
                    this.msg = 'ลบรายการสำเร็จ';
                });
            }).catch(() => {
                this.showLoadingModal();
                this.status_loading = 3;
                this.msg = 'ลบรายการไม่สำเร็จ';
            });
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        searchSaleReturnProducts(page) {
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            this.showLoadingModal();
            this.event_submit = true;
            let customer_id = '';
            if (this.search.customer) {
                customer_id = this.search.customer.id;
            }
            //change date format
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            let data = {
                customer_id,
                invoice_id: this.search.invoice_id,
                start_date,
                end_date,
                product_id: this.search.product ? this.search.product.id : '',
                cn_number: this.search.cn_number
            }
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("SaleReturnProduct/search", {
                page,
                data,
            }).then(() => {
                this.hideLoadingModal();
            }).catch(() => {
                this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                this.status_loading = 3;
            })
        },
        getSaleReturnProducts() {
            if (this.event_submit) {
                this.searchSaleReturnProducts(this.dataPaginate.current_page);
            } else {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = 'กรุณารอสักครู่';
                this.$store.dispatch('SaleReturnProduct/setSaleReturnProduct', this.dataPaginate.current_page).then(() => {
                    this.hideLoadingModal();
                })
            }
        },
        printSaleReturnProduct(id) {
            window.open(domain + '/sale-return-product-pdf/' + id, '_blank')
        },
        toForm1() {
            this.$store.dispatch("SaleReturnProduct/clearDataForm").then(() => {
                this.$store.dispatch("SaleReturnProduct/clearCustomer")
            });
            this.$router.push({path: "/sale-return-products-form1"});
        },
        generateCreditNote() {
            if (this.checkbox_id.length > 0) {
                this.showLoadingModal();
                this.msg = 'กำลังสร้างใบลดหนี้ กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch("SaleReturnProduct/saveCreditNote", {
                    id: this.checkbox_id,
                }).then(() => {
                    this.msg = 'สร้างใบลดหนี้สำเร็จ';
                    this.status_loading = 2;
                }).catch(err => {
                    //console.log(err);
                    this.msg = 'สร้างใบลดหนี้ไม่สำเร็จ';
                    this.status_loading = 3;
                });
            }
        }
    }
}
</script>

<style scoped>
.select {
    border: 0
}
</style>
